// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class BillPriceListItemResource extends Resource {
    basePath: string = 'billing/bill-price-list-item/';

    objectPath: string = 'billing/bill-price-list-item/{ident}/';
}
